import classNames from 'classnames';
import React from 'react';
import { primary, primaryGray } from '../../Styles/Colours';
import { Button, ButtonMode } from '../Button';
import { ArrowLeftIcon } from '../Icons';
import styles from './StyledDialog.module.scss';

export enum SidePanelSizes {
    Small,
    Normal
}

export const DialogSidebar: React.FC<{
    collapsed: boolean;
    preventSideBarCollapse?: boolean;
    sidePanelSize?: SidePanelSizes;
    onToggle(): void;
    sidebarRender(props: { collapsed: boolean }): React.ReactNode;
}> = props => {
    const collapsed = props.preventSideBarCollapse ? false : props.collapsed;

    const sidebarClass = classNames(styles.sidebar, {
        [styles.sidebarClosed]: collapsed,
        [styles.sideBarSmall]: props.sidePanelSize === SidePanelSizes.Small
    });

    const sidebarToggle = classNames(styles.closeButton, {
        [styles.closeButtonCollapsed]: collapsed
    });

    const dialogContentShade = classNames(styles.dialogContentShade, {
        [styles.sideBarLockedOpen]: !!props.preventSideBarCollapse,
        [styles.shadeVisible]: !collapsed
    });

    const sidebarToggleTitle = collapsed ? 'Open sidebar' : '';

    return (
        <>
            <aside className={sidebarClass}>
                {props.sidebarRender({ collapsed })}
                {!props.preventSideBarCollapse && (
                    <Button
                        testId={'sidebar-collaspse'}
                        mode={ButtonMode.text}
                        title={sidebarToggleTitle}
                        className={sidebarToggle}
                        startIcon={<ArrowLeftIcon className={styles.sidebarToggleIcon} color={primaryGray} />}
                        onClick={props.onToggle}
                    >
                        <div className={styles.sidebarToggleText}>Collapse</div>
                    </Button>
                )}
            </aside>
            <span className={dialogContentShade} onClick={props.onToggle} />
        </>
    );
};
